import { toJalaali } from "jalaali-js";

const months = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

export function toPersianDate(input?: string | Date | null): string {
  if (!input) return "";

  const date = input instanceof Date ? input : new Date(input);

  if (isNaN(date.getTime())) return "";

  const { jy, jm, jd } = toJalaali(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
  );

  return `${jd} ${months[jm - 1]} ${jy}`;
}
